module.exports = __webpack_public_path__ + "img/orbite_grossite.0acff28.png";